import { Link } from 'react-router-dom';

export interface AlbumProps {
    title: string;
    to: string;
    path: string;
    alt?: string;
    externalUrl?: string;
}

const Album = ({ title, to, path, alt = '', externalUrl }: AlbumProps) => {
    return (
        <div className="col-lg-4 col-sm-6" data-aos="fade-up" data-aos-delay="100">
            <div className="album-item">
                <Link className="album-item-link" to={to}>
                    <div className="album-item-hover">
                        <div className="album-item-hover-content">
                            <i className="bi bi-box-arrow-up-right h1"></i>
                        </div>
                    </div>
                    <img className="img-fluid" src={path} alt={alt} />
                </Link>
                <div className="album-item-caption">
                    {externalUrl
                        ? <a className="album-item-caption-heading" href={externalUrl} target="_blank" rel="noopener noreferrer">{title}</a>
                        : <div className="album-item-caption-heading">{title}</div>
                    }
                </div>
            </div>
        </div>
    );
};

export default Album;